// Shared by the data rows and the skeleton rows so both stripe and size alike.
export const BODY_ROW_CLASSES =
  "tw:border-b tw:border-(--color-border) tw:bg-(--color-surface) tw:even:bg-(--color-warm-gray-light) tw:hover:bg-(--color-warm-gray-light) tw:even:hover:bg-muted";

// Pinned cells are sticky, so they inherit the row background to cover the
// cells scrolling beneath them.
export const BODY_CELL_CLASSES =
  "tw:overflow-hidden tw:bg-inherit tw:px-2 tw:py-2 tw:text-start tw:text-sm tw:text-ellipsis tw:whitespace-nowrap tw:text-(--color-text-primary)";
